import React, { useState, useEffect } from 'react';
// import { Form, Checkbox, Select, Input } from 'antd';
import {
  Radio,
  Select,
  Form,
  Button,
  Row,
  Col,
  Upload,
  Progress,
  Tag,
  InputNumber,
  message
} from 'antd';
import styles from './styles.module.less';
import Profilephoto from '@/common/assets/images/Profile.png';
import Familyphoto from '@/common/assets/images/Family.png';
import selfFamilyphoto from '@/common/assets/images/self_family.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { deleteImage_BE } from '../redux/slice';

const Edit = ({
  get_hobbies_list,
  get_sports_list,
  maritial_Status,
  onsubmit,
  user_data,
  loading
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  console.log('user_data', user_data?.Profiles?.[0]?.height_ft);

  const [interest, setInterest] = useState('');
  console.log('interest', interest);

  const [isDisabled, setIsDisabled] = useState(false);
  const [images, setImages] = useState({
    profilePhoto: { id: '', profile_id: '', url: null },
    familyPhoto: { id: '', profile_id: '', url: null },
    selfFamilyPhoto: { id: '', profile_id: '', url: null }
  });

  const [isUploadDisabled, setIsUploadDisabled] = useState({
    profilePhoto: false,
    familyPhoto: false,
    selfFamilyPhoto: false
  });

  console.log('images', images);

  const [fileData, setFileData] = useState('');

  const handleImageUpload = (info, type) => {
    const file = info.file;
    if (file) {
      const imageURL = URL.createObjectURL(file);

      const uploadedImage = {
        id: '',
        profile_id: '',
        url: imageURL
      };

      // setImages((prev) => ({
      //   ...prev,
      //   [type]: uploadedImage
      // }));

      // Set new image
      setImages((prev) => ({
        ...prev,
        [type]: uploadedImage
      }));

      // Store the new file
      setFileData((prev) => ({
        ...prev,
        [type]: file
      }));

      setIsUploadDisabled((prev) => ({ ...prev, [type]: true })); // Disable upload

      // setFileData((prev) => ({
      //   ...prev,
      //   [type]: file // Store file with type key
      // }));

      // Set form field (optional)
      form.setFieldsValue({ [type]: file });
    }
  };

  // const handleImageDelete = async (e, type) => {
  //   e.stopPropagation();

  //   // If there is a Blob URL already, revoke it to free memory
  //   if (images[type]?.url) {
  //     URL.revokeObjectURL(images[type].url);
  //   }

  //   const imageId = images[type]?.id;

  //   setImages((prevImages) => ({
  //     ...prevImages,
  //     [type]: { id: '', profile_id: '', url: null } // ✅ Reset object
  //   }));

  //   setIsUploadDisabled((prev) => ({ ...prev, [type]: false }));
  //   form.setFieldsValue({ [type]: null });

  //   // 🧹 Remove the file from fileData
  //   setFileData((prev) => {
  //     const updated = { ...prev };
  //     delete updated[type];
  //     return updated;
  //   });

  //   if (imageId) {
  //     try {
  //       // await deleteImage_BE(imageId);
  //       await dispatch(deleteImage_BE({ id: imageId })).unwrap();
  //       console.log(`Image with ID ${imageId} deleted successfully`);
  //     } catch (error) {
  //       console.error('Error deleting image:', error);
  //     }
  //   }
  // };

  const handleImageDelete = async (e, type) => {
    e.stopPropagation();

    // If there is a Blob URL already, revoke it to free memory
    if (images[type]?.url) {
      URL.revokeObjectURL(images[type].url);
    }

    const imageId = images[type]?.id; // Existing DB ID

    // Reset the images[type]
    setImages((prevImages) => ({
      ...prevImages,
      [type]: { id: '', profile_id: '', url: null }
    }));

    // Reset fileData[type]
    setFileData((prevFiles) => {
      const updatedFiles = { ...prevFiles };
      delete updatedFiles[type]; // Delete the file entry
      return updatedFiles;
    });

    // Reset the form field value
    form.setFieldsValue({ [type]: null });

    setIsUploadDisabled((prev) => ({
      ...prev,
      [type]: false
    }));

    if (imageId) {
      try {
        await dispatch(deleteImage_BE({ id: imageId })).unwrap();
        console.log(`Image with ID ${imageId} deleted successfully`);
        message.success('Image deleted successfully');
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
      } catch (error) {
        console.error('Error deleting image:', error);
        message.error('Failed to delete image. Please try again.');
      }
    }
  };

  // // Images Section End  //
  const onFinish = (values) => {
    values['files'] = fileData;
    console.log('formData', values);
    onsubmit(values);
  };

  const handleSelectChange = (value, field) => {
    // setFormData((prev) => ({ ...prev, [field]: value }));
    setInterest((prev) => ({ ...prev, [field]: value }));
  };

  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };

  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };

  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];

  const handleFormChange = (_, allValues) => {
    setIsDisabled(allValues.is_disabled === 'yes');
  };

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  // console.log('matUserObject', userName);

  useEffect(() => {
    if (user_data?.Profiles?.[0]) {
      const profile = user_data.Profiles[0];
      const hobbyInterests = user_data?.Profiles?.[0]?.ProfileInterests.filter(
        (item) => item.HobbySport.type === 'hobby'
      ).map((item) => item.HobbySport.id);

      const sportInterests = user_data?.Profiles?.[0]?.ProfileInterests.filter(
        (item) => item.HobbySport.type === 'sport'
      ).map((item) => item.HobbySport.id);

      const getImageByIndex = (images, index) => {
        const img = images?.[index];
        return img
          ? { id: img.id, profile_id: img.profile_id, url: img.objectKey }
          : { id: '', profile_id: '', url: null };
      };

      const profileImages = profile?.ProfileImages || [];
      const mappedImages = {
        profilePhoto: getImageByIndex(profileImages, 0),
        familyPhoto: getImageByIndex(profileImages, 1),
        selfFamilyPhoto: getImageByIndex(profileImages, 2)
      };

      setImages(mappedImages);
      setIsUploadDisabled({
        profilePhoto: !!mappedImages.profilePhoto.url,
        familyPhoto: !!mappedImages.familyPhoto.url,
        selfFamilyPhoto: !!mappedImages.selfFamilyPhoto.url
      });
      setIsDisabled(
        user_data?.Profiles?.[0]?.is_disabled === true ? 'yes' : false
      );
      form.setFieldsValue({
        height: user_data?.Profiles?.[0]?.height_cms || '',
        weight: user_data?.Profiles?.[0]?.weight || '',
        is_disabled:
          user_data?.Profiles?.[0]?.is_disabled === true ? 'yes' : 'none',
        disability_text: user_data?.Profiles?.[0]?.diabled_description || '',
        marital_status_id: user_data?.Profiles?.[0]?.MaritalStatus?.id,
        self_description: user_data?.Profiles?.[0]?.self_description || '',
        hobby_interests: hobbyInterests || '',
        sport_interests: sportInterests || '',
        other_interests: user_data?.Profiles?.[0]?.other_interests || '',
        profilePhoto: mappedImages.profilePhoto.url,
        familyPhoto: mappedImages.familyPhoto.url,
        selfFamilyPhoto: mappedImages.selfFamilyPhoto.url
      });
    }
  }, [user_data, form]);

  const percent = user_data?.user_score;
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };
  const getTagColor = (label) => {
    const safeLabel = String(label || ''); // Convert to string, avoid null/undefined error

    if (safeLabel.toLowerCase().includes('sport')) return '#D20B0B';
    if (safeLabel.toLowerCase().includes('hobby')) return '#D20B0B';
    return 'rgba(210, 11, 11, 0.11)';
  };

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    return (
      <Tag
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 5,
          backgroundColor: getTagColor(label),
          color: '#d20b0b',
          borderRadius: '12px',
          padding: '0px 6px'
        }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <div className={styles.maincontainer}>
      <div className={styles.editOuter}>
        <div className={styles.singleContainer}>
          <Row
            gutter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <Form
                form={form}
                layout="vertical"
                initialValues={interest}
                onValuesChange={handleFormChange}
                onFinish={onFinish}
              >
                <div className={styles.detailSide}>
                  <div className={styles.detailName}>
                    <div className={styles.nameflex}>
                      <div className={styles.idname}>
                        <h1 className={styles.dName}> {userName} </h1>
                      </div>
                      <Row gutter={[8, 8]} wrap>
                        <Col className={styles.progressname}>
                          <Progress
                            size="small"
                            type="circle"
                            percent={percent}
                            strokeColor={getStrokeColor(percent)}
                          />
                          <h6 className={styles.matchpercent}>
                            away to find your life partner
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <div className={styles.changes}></div>
                  </div>
                  <div style={{}}>
                    <div className={styles.detailsOuter}>
                      <div className={styles.detailsInner}>
                        <div className={styles.detailsInside}>
                          {/* New code */}
                          <div className={styles.searchTab}>
                            {Object.keys(routes).map((section) => (
                              <div
                                key={section}
                                className={`${styles.searchTabHeader} ${
                                  activeTab === section ? styles.activeTab : ''
                                }`}
                                onClick={() => handleSectionClick(section)}
                              >
                                {section}
                              </div>
                            ))}
                          </div>
                          {/* {openSections.aboutMe && <AboutMe />} */}
                          <div className={styles.personalOne1}>
                            <div className={styles.personalCol}>
                              {/** education */}
                              <div className={styles.ageContainer}>
                                <div className={styles.countryRangeContainer}>
                                  <div className={styles.heightcontent}>
                                    <div
                                      className={styles.selectContainerCountry}
                                    >
                                      <Form.Item
                                        name="height"
                                        label="Height(in cm)"
                                        rules={[
                                          {
                                            required: false,
                                            message: 'Height is required'
                                          },
                                          {
                                            validator: (_, value) =>
                                              value >= 100 && value <= 250
                                                ? Promise.resolve()
                                                : Promise.reject(
                                                    new Error(
                                                      'Height must be between 100 and 250 cm'
                                                    )
                                                  )
                                          }
                                        ]}
                                      >
                                        <InputNumber
                                          placeholder="Enter height"
                                          min={100}
                                          max={250}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className={styles.selectContainerCountry}
                                    >
                                      <Form.Item
                                        name="weight"
                                        label="Weight(in kg)"
                                        rules={[
                                          {
                                            required: false,
                                            message: 'Weight is required'
                                          },
                                          {
                                            validator: (_, value) =>
                                              value >= 30 && value <= 200
                                                ? Promise.resolve()
                                                : Promise.reject(
                                                    new Error(
                                                      'Weight must be between 30 and 200 kg'
                                                    )
                                                  )
                                          }
                                        ]}
                                      >
                                        <InputNumber
                                          placeholder="Enter weight"
                                          min={30}
                                          max={200}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  {/* </Form.Item> */}
                                </div>
                                <div className={styles.countryRangeContainer}>
                                  <div className={styles.heightcontent}>
                                    <div
                                      className={styles.selectContainerCountry}
                                    >
                                      <div className={styles.checkboxFamily}>
                                        <div className={styles.familyInner}>
                                          <Form.Item
                                            name="is_disabled"
                                            label="Disabilities"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  'Please select disabilities status!'
                                              }
                                            ]}
                                          >
                                            <Radio.Group>
                                              <Row
                                                gutter={[24]}
                                                className={styles.radiobuttons}
                                              >
                                                <Col span={12}>
                                                  <Radio value="none">
                                                    None
                                                  </Radio>
                                                </Col>
                                                <Col span={12}>
                                                  <Radio value="yes">Yes</Radio>
                                                </Col>
                                              </Row>
                                            </Radio.Group>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*  */}
                          {isDisabled && (
                            <>
                              <Form.Item
                                name="disability_text"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      'Please enter disabilities details!'
                                  }
                                ]}
                              >
                                <textarea
                                  className={styles.textareaOne}
                                  placeholder="Please enter disabilities "
                                ></textarea>
                              </Form.Item>
                            </>
                          )}
                          {/*  */}
                          {/** two */}
                          <div className={styles.personalOne}>
                            <div className={styles.personalCol}>
                              <div>
                                <div className={styles.ageRangeContainer}>
                                  <Form.Item
                                    label="Marital Status"
                                    name="marital_status_id"
                                  >
                                    <Radio.Group
                                      name="marital_status_id"
                                      // className={styles.radiobuttons}
                                    >
                                      <Row
                                        gutter={[24]}
                                        className={styles.radiobuttons}
                                      >
                                        {maritial_Status?.length
                                          ? maritial_Status.map((mstatus) => (
                                              <Col
                                                xl={6}
                                                lg={6}
                                                md={6}
                                                sm={24}
                                                xs={24}
                                                key={mstatus.id}
                                              >
                                                <Radio
                                                  key={mstatus.id}
                                                  value={mstatus.id}
                                                  className={styles.radioInner}
                                                >
                                                  {mstatus.marital_status}
                                                </Radio>
                                              </Col>
                                            ))
                                          : null}
                                      </Row>
                                    </Radio.Group>
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={styles.uploadSection}>
                            {[
                              'profilePhoto',
                              'familyPhoto',
                              'selfFamilyPhoto'
                            ].map((type) => (
                              <div key={type} className={styles.uploadItem}>
                                <Form.Item
                                  name={type}
                                  rules={[
                                    {
                                      required: type === 'profilePhoto', // Only make Profile Photo required
                                      message: `${
                                        type === 'profilePhoto'
                                          ? 'Profile Photo'
                                          : 'Photo'
                                      } is required`
                                    }
                                  ]}
                                >
                                  <Upload
                                    accept="image/*"
                                    beforeUpload={() => false} // Prevent automatic upload
                                    showUploadList={false} // Hide default list
                                    onChange={(info) =>
                                      handleImageUpload(info, type)
                                    }
                                    disabled={isUploadDisabled[type]} // Disable conditionally
                                  >
                                    <label
                                      htmlFor={`${type}Input`}
                                      className={styles.uploadCircle}
                                    >
                                      <div className={styles.imageContainer}>
                                        {images[type]?.url ? (
                                          <>
                                            {/* Delete Button (Top-Right of Image) */}
                                            <button
                                              className={styles.deleteButton}
                                              onClick={(e) =>
                                                handleImageDelete(e, type)
                                              }
                                            >
                                              <DeleteOutlined />
                                              {/* ❌ */}
                                            </button>
                                            <img
                                              src={images[type]?.url}
                                              alt={type}
                                              className={styles.uploadedImage}
                                            />
                                          </>
                                        ) : (
                                          <div className={styles.iconContainer}>
                                            <span
                                              className={styles.profileicon}
                                            >
                                              <img
                                                src={
                                                  type === 'profilePhoto'
                                                    ? Profilephoto
                                                    : type === 'familyPhoto'
                                                    ? Familyphoto
                                                    : selfFamilyphoto
                                                }
                                                alt={`${type} icon`}
                                              />
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </label>
                                  </Upload>
                                </Form.Item>

                                <div className={styles.label}>
                                  {type === 'profilePhoto' && '*Profile Photo'}
                                  {type === 'familyPhoto' && 'Family Photo'}
                                  {type === 'selfFamilyPhoto' &&
                                    'Self/Family Photo'}
                                </div>
                              </div>
                            ))}
                          </div>

                          {/** five  */}
                          <div className={styles.descriptionstyle}>
                            <div>
                              <Form.Item
                                label="Find someone that admires who you are"
                                name="self_description"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      'Please describe yourself in a few words.'
                                  }
                                ]}
                              >
                                <textarea
                                  name="self_description"
                                  className={styles.textareaTwo}
                                  placeholder="Write a few words to describe real you, Let the world know you awesomeness! "
                                ></textarea>
                              </Form.Item>
                            </div>
                          </div>

                          {/** thrid heading  */}
                          <div className={styles.thirdHeading}>
                            PERSONAL INTEREST
                          </div>

                          {/** THIRD  */}
                          <div className={styles.personalOne}>
                            <div
                              style={{
                                display: 'flex',
                                gap: '10px',
                                width: '100%'
                              }}
                              className={styles.persionalInterests}
                            >
                              <div className={styles.hobbiescontainer}>
                                <Form.Item
                                  label="Hobbies"
                                  name="hobby_interests"
                                  className={styles.ageLabel}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please select hobbies'
                                    }
                                  ]}
                                >
                                  <Select
                                    className={styles.customSelectHob}
                                    mode="multiple"
                                    onChange={(value) =>
                                      handleSelectChange(
                                        value,
                                        'hobby_interests'
                                      )
                                    }
                                    showSearch
                                    placeholder="Select hobbies"
                                    showArrow={true}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option?.children
                                        ?.toLowerCase()
                                        ?.includes(input.toLowerCase())
                                    }
                                    tagRender={tagRender}
                                  >
                                    {get_hobbies_list?.map((ghl) => (
                                      <Select.Option
                                        key={ghl?.id}
                                        value={ghl?.id}
                                      >
                                        {ghl?.activity}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>

                              <div className={styles.countryRangeContainer}>
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '9px',
                                    width: '100%'
                                  }}
                                >
                                  <div
                                    style={{
                                      paddingTop: '5px',
                                      width: '100%'
                                    }}
                                  >
                                    <Form.Item
                                      label="Sports"
                                      name="sport_interests"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select sports'
                                        }
                                      ]}
                                    >
                                      <Select
                                        className={styles.customSelectHob}
                                        mode="multiple"
                                        onChange={(value) =>
                                          handleSelectChange(
                                            value,
                                            'sport_interests'
                                          )
                                        }
                                        showSearch
                                        placeholder="Select sports"
                                        showArrow={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            ?.toLowerCase()
                                            ?.includes(input.toLowerCase())
                                        }
                                        tagRender={tagRender} // Add custom tag renderer
                                      >
                                        {get_sports_list?.length
                                          ? get_sports_list?.map(
                                              (gsl, index) => {
                                                return (
                                                  <option
                                                    value={gsl?.id}
                                                    key={index}
                                                  >
                                                    {gsl?.activity}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/** four */}
                          <div className={styles.personalOne}>
                            <div>
                              <Form.Item
                                label="Other Interests"
                                name="other_interests"
                              >
                                <textarea
                                  className={styles.textareaOne}
                                  placeholder="Describe your other interest like travel. etc "
                                ></textarea>
                              </Form.Item>
                            </div>
                          </div>
                          <br />

                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className={styles.submitbutton}
                              loading={loading}
                              disabled={loading}
                            >
                              Save & Next
                            </Button>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Edit;
